import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { isMobileOnly as isMobile } from 'react-device-detect';
import { useQuery } from 'react-query';
import FuturesGraphMobile from '../futures-graph-mobile';
import './futures-graph-widget.m.css';
import OpenInterestChangeWidget from './open-interest-change';
import SearchFuturesOptions from './search-stocks';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { isWithinTradingHours } from '../../../../../helpers/utils';

const FuturesGraphWidget = ({ widget = false }) => {
  const [futuresOptionData, setFuturesOptionsData] = useState({});
  const [selectedStock, setSelectedStock] = useState('NIFTY 50');
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [count, setCount] = useState(0);
  const tradingHolidays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'trading_holidays'], []),
  );
  const specialTradingDays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'special_trading_days'], {}),
  );

  const getFuturesOptionOverallDataForQueryForFutures = async (stockName) => {
    const response = await fetch(`/foapi/future/getSummary?exchangeSymbol=${stockName}`);
    return response.json();
  };

  const resultFuturesOptionsSummaryForFutures = useQuery(
    'getFuturesOptionsSummaryForFutures',
    () => getFuturesOptionOverallDataForQueryForFutures(selectedStock),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: (data) => {
        setFuturesOptionsData(data?.data);
      },
      enabled:
        initialLoading ||
        (!!selectedStock && isWithinTradingHours(tradingHolidays, specialTradingDays)),
    },
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (resultFuturesOptionsSummaryForFutures?.isSuccess) {
      setFuturesOptionsData(resultFuturesOptionsSummaryForFutures?.data?.data);
    }
  }, []);

  const getFuturesOptionOverallData = async (stockName) => {
    const data = await getFuturesOptionOverallDataForQueryForFutures(stockName);
    setFuturesOptionsData(data?.data);
  };

  const stockSearchHandler = (stockName) => {
    setSelectedStock(stockName);
    const formatedStockName = stockName.replace(' ', '%20');
    setLoading(true);
    getFuturesOptionOverallData(formatedStockName);
    setLoading(false);
  };

  const stockSearchCloseHandler = (defaultStatus) => {
    if (defaultStatus) {
      setSelectedStock('NIFTY 50');
    }
    setCount((current) => current + 1);
  };

  const summaryKeymaps = [
    { key: 'spot-price', label: 'Spot Price' },
    { key: 'basis', label: 'Basis' },
    { key: '1m-future', label: '1M Futures' },
    { key: '2m-future', label: '2M Futures' },
    { key: 'roll-spread', label: 'Rollover Spread' },
    { key: 'roll-over-percentage', label: 'Rollover%' },
    { key: 'open-interest', label: 'Open Interest' },
    { key: 'open-interest-change-percentage', label: 'OI% Change' },
    { key: 'put-call-ratio', label: 'Put Call Ratio' },
  ];

  return (
    <React.Fragment>
      {initialLoading ? (
        <div styleName="initial-loading-container"></div>
      ) : (
        <>
          {!isMobile ? (
            <div styleName="fut-opt-container" className="desktop-only">
              <>
                <div styleName="futures-header-alt">
                  <div styleName="letter-container-alt">
                    <span styleName="letter-alt">{selectedStock?.toString()?.charAt(0)}</span>
                  </div>
                  <div>
                    <SearchFuturesOptions
                      onStockSearch={stockSearchHandler}
                      onCloseSearch={stockSearchCloseHandler}
                    />
                  </div>

                  <div styleName="statistics-container">
                    {summaryKeymaps.map((keymap) => (
                      <div styleName="stats">
                        <p styleName="stat-value">
                          {futuresOptionData && futuresOptionData?.[keymap.key]
                            ? futuresOptionData?.[keymap.key]
                            : '-'}{' '}
                          <br /> <span styleName="stat-desc">{keymap.label}</span>
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
                <div styleName="chart-container">
                  <OpenInterestChangeWidget
                    maintainAspectRatio={true}
                    responsive={true}
                    stockName={selectedStock}
                    loadingStatus={loading}
                    countStatus={count}
                    flag={'change'}
                  />
                  <OpenInterestChangeWidget
                    maintainAspectRatio={true}
                    responsive={true}
                    stockName={selectedStock}
                    loadingStatus={loading}
                    countStatus={count}
                    flag={'distribution'}
                  />
                </div>
              </>
            </div>
          ) : (
            <div className="mobile-only">
              <FuturesGraphMobile widget={widget} />
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
};

FuturesGraphWidget.propTypes = {
  maintainAspectRatio: PropTypes.bool,
  responsive: PropTypes.bool,
};

export default FuturesGraphWidget;
